import * as React from 'react';

import { SkipNavContent } from '@reach/skip-nav';
import styled from 'styled-components';

import {
  CONTACT,
  FOOTER_LINK_SECTIONS,
  HEADER_LINK_SECTIONS,
  OTHER_SITE_LINKS,
  SITE_LOCALE,
} from 'app-constants';

import { Footer } from 'stile-shared/src/components/2020/common/Footer';
import { Main } from 'stile-shared/src/components/2020/common/Primitives';
import { SiteSwitchModal } from 'stile-shared/src/components/2020/common/SiteSwitchModal';
import { Header } from 'stile-shared/src/components/2024/common/Header';

import STS4Badge from '../../../../stile-shared/assets/images/privacy/safer_technologies_for_schools_badge.png';

export type PageLayoutProps = {
  children: React.ReactNode;
};

export function PageLayout({ children }: PageLayoutProps) {
  return (
    <>
      <PageContainer>
        <Header headerLinks={HEADER_LINK_SECTIONS} enquireNowGtagEvent="enquire_now_au" />

        <SiteSwitchModal locale={SITE_LOCALE} />

        <Main>
          <SkipNavContent />
          {children}
        </Main>

        <Footer
          locale={SITE_LOCALE}
          phone={CONTACT.au.phone}
          linkSections={FOOTER_LINK_SECTIONS}
          otherLinks={OTHER_SITE_LINKS}
          badges={[
            {
              text: 'Stile has been assessed by Safer Technologies for Schools',
              url: 'https://st4s.edu.au/',
              src: STS4Badge,
              width: 80,
            },
          ]}
          statement={CONTACT.au.address.descriptive}
        />
      </PageContainer>
    </>
  );
}

export const PageContainer = styled.div`
  display: grid;
  grid-template-rows: min-content 1fr min-content;
  width: 100%;
  height: 100%;
`;
